import React from "react";
import { useField, useFormikContext } from "formik";

type FormInputProps = {
  type?: string;
  placeholder: string;
  required?: boolean;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const FormInput: React.FC< FormInputProps> = ({ type = "text",
  placeholder,
  required = false,
  name,
  onChange,
 }) => {
  const [field, meta] = useField(name);
  const formik = useFormikContext<any>();
  const errorId = `${name}-error`;
  // show error when field touched OR user attempted to submit the form
  const showError = !!((meta.touched || formik?.submitCount > 0) && meta.error);

  return (
    <div className="input-group relative w-full">
      <input
        id={name}
        {...field}
        type={type}
        className="input text-subtitle-4 font-bold"
        placeholder=" " // for floating label patterns
        aria-label={placeholder}
        aria-describedby={errorId}
        aria-required={required}
        // call Formik's onChange and the optional parent onChange
        onChange={(e) => {
          field.onChange(e);
          if (onChange) onChange(e);
        }}
        onBlur={(e) => {
          field.onBlur(e);
        }}
      />

      <label htmlFor={name} className="text-[12px] font-regular">
        {placeholder}
        {required ? "*" : ""}
      </label>

      {showError && (
        <div
          id={errorId}
          className="text-red-500 text-xs font-medium flex mt-2 mb-0 ml-1"
          role="alert"
        >
          {meta.error}
        </div>
      )}
    </div>
  );
};
export default FormInput;